import { AddressCardIcon } from "@/components/atoms/icons";
import { PresenteeismPermission } from "@/presenteeism/models/PresenteeismPermission";

import { IGIREMenuItem } from "../../models/router.types";
import { PathNamekAppsRoutes } from "../../constants";

export const presenteeismMenuItems: IGIREMenuItem[] = [
  {
    label: "Presentismo",
    icon: <AddressCardIcon size={18} />,
    data: PathNamekAppsRoutes.PRESETEEISM,
    align: "start",
    permission: {
      must: [
        PresenteeismPermission.ASSOCIATES,
        PresenteeismPermission.EMPLOYEES,
        PresenteeismPermission.REPORT,
        PresenteeismPermission.RUTAS,
      ],
      exhaustive: false,
    },
    items: [
      {
        label: "Rutas",
        url: `/#/${PathNamekAppsRoutes.PRESETEEISM}/rutas`,
        permission: {
          must: PresenteeismPermission.RUTAS,
        },
      },
      {
        label: "Empleados",
        url: `/#/${PathNamekAppsRoutes.PRESETEEISM}/empleados`,
        permission: {
          must: PresenteeismPermission.EMPLOYEES,
        },
      },
      {
        label: "Asociados",
        url: `/#/${PathNamekAppsRoutes.PRESETEEISM}/asociados`,
        permission: {
          must: PresenteeismPermission.ASSOCIATES,
        },
      },
      {
        label: "Reporte de presentismo",
        url: `/#/${PathNamekAppsRoutes.PRESETEEISM}/reporte`,
        permission: {
          must: PresenteeismPermission.REPORT,
        },
      },
      {
        label: "Generador de precintos",
        url: `/#/${PathNamekAppsRoutes.PRESETEEISM}/generador-precintos`,
        permission: {
          must: PresenteeismPermission.SEALBATCHES,
        },
      },
    ],
  },
];
